import { z } from 'zod';

export const flatSchema = z.object({
  id: z.number(),
  immowelt_id: z.string().nullable(),
  title: z.string(),
  price: z.number().nullable(),
  size: z.number(),
  rooms: z.number(),
  link: z.string().url(),
  is_active: z.boolean(),
  latitude: z.number().nullable(),
  longitude: z.number().nullable(),
  postcode: z.string(),
  city: z.string().nullable(),
  district: z.string().nullable(),
  street: z.string().nullable(),
  estate_type: z.string(),
  estate_subtype: z.string().nullable(),
  distribution_type: z.string().nullable(),
  construction_year: z.number().nullable(),
  features: z.array(z.string()).nullable(),
  features_unique: z.array(z.string()).catch([]),
  broker_name: z.string().nullable(),
  broker_type: z.string().nullable(),
  online_id: z.string().nullable(),
  cold_rent: z.number().nullable(),
  warm_rent: z.number().nullable(),
  currency: z.string().nullable(),
  image_urls: z.array(z.string().url()),
  details_scraped: z.boolean(),
  additional_description: z.string().nullable(),
  created_at: z.string(),
  updated_at: z.string(),
  site: z.string(),
  potential_postcodes: z.array(z.string()),
  residents: z.number().nullable(),
  available_from: z.string().nullable(),
  available_to: z.string().nullable(),
  shared_flat_properties: z.string().nullable().or(z.record(z.any())),
  shared_flat: z.boolean(),
  original_site_id: z.string().nullable(),
  is_flat: z.boolean(),
  generated_title: z.string().nullable(),
}).transform((data) => ({
  ...data,
  title: data.generated_title || data.title
}));

export type Flat = z.infer<typeof flatSchema>;

export const hardMatchSchema = z.object({
    id: z.number(),
    flat_id: z.number(),
    match_timestamp: z.string(),
    handled: z.boolean(),
    soft_match_score: z.number().nullish(),
    soft_match_reason: z.string().nullish(),
    soft_match_checklist: z.array(
      z.object({
        type: z.enum(['good', 'bad', 'warning']),
        reason: z.string()
      })
    ).nullable().catch([]).transform(items => items ?? []),
    close_match_properties: z.string().nullish(),
    state: z.enum(['hidden', 'applied']).nullable(),
    flat: flatSchema,
  });
  
  type HardMatch = z.infer<typeof hardMatchSchema>;
  
  export default HardMatch;